module.exports = __webpack_public_path__ + "img/bianjie3.a4e58b16.png";